import { Redirect, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Loader from 'src/common/Loader';
import ROUTE from 'src/utils/routeConstants';
import { isTyreManagementV2Enabled } from 'src/utils/tyreManagementFeature';
import VehicleEditPage from './VehicleEditPage';

const VehicleEditRoute = () => {
  const { vehicleId } = useParams();
  const { appSettings, appSettingsLoaded } = useSelector((state) => state.settings);

  if (!appSettingsLoaded) return <Loader />;

  const v2Enabled = isTyreManagementV2Enabled(appSettings)
    && appSettings?.vehicle_details_v2_enabled === true;

  if (!v2Enabled) {
    return <Redirect to={`${ROUTE.vehicles}/${vehicleId}`} />;
  }

  return <VehicleEditPage />;
};

export default VehicleEditRoute;
